import React, { Component } from 'react';
import './SubMenuHeader.css';
import ParameterErrors from '../errors/ParameterErrors';
import IconButtonNonReact from './IconButtonNonReact';
import IconButton from './IconButton';
import { faBackward, faTimes} from '@fortawesome/free-solid-svg-icons'
import Urls from '../urls/Urls';
const{throwNotProvided}=ParameterErrors;
export default class SubMenuHeaderNonReact {
	constructor(props){
		const {title, children, menuManager}=props;
		this._iMenuManager = menuManager;
		this._children = children;
		this._hasChildren=children?true:false;
		this._handleClickButtonBack= this._handleClickButtonBack.bind(this);
		this._handleClickButtonClose= this._handleClickButtonClose.bind(this);
		this._iMenuManager = menuManager;
		this._element = document.createElement('div');
		this._element.classList.add('sub-menu-header');
		if(this._hasChildren)
			this._element.classList.add('has-children');
		
		const childrenElement = document.createElement('div');
		childrenElement.classList.add('children');
		if(this._children)
			this._children.forEach(child=>childrenElement.appendChild(child));
		this._element.appendChild(childrenElement);
		const titleElement = document.createElement('div');
		titleElement.classList.add('title');
		titleElement.innerHTML = title;
		this._element.appendChild(titleElement);
		
		const backButtonWrapperElement = document.createElement('div');
		backButtonWrapperElement.classList.add('button-back-wrapper');
		this._element.appendChild(backButtonWrapperElement);
		
		const closeButtonWrapperElement = document.createElement('div');
		closeButtonWrapperElement.classList.add('button-close-wrapper');
		this._element.appendChild(closeButtonWrapperElement);
		
		this._iconButtonNonReactBack = new IconButtonNonReact({imgUrl:Urls.assets+'icons/UI_Button_Open.png', onClick:this._handleClickButtonBack});
		backButtonWrapperElement.appendChild(this._iconButtonNonReactBack.element);
		
		this._iconButtonNonReactClose = new IconButtonNonReact({imgUrl:Urls.assets+'icons/UI_Button_Exit.png', onClick:this._handleClickButtonClose});
		closeButtonWrapperElement.appendChild(this._iconButtonNonReactClose.element);

	}
	get element(){
		return this._element;
	}
	_handleClickButtonBack(){
		if(this._iMenuManager)
			this._iMenuManager.back();
	}
	_handleClickButtonClose(){
		if(this._iMenuManager)
			this._iMenuManager.close();
	}
}
